import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { errorHandler } from "../../../util/errorHandler";
import PayApi from "../../../api/pay.api";
import moment from "moment";

const SubscribeDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  // mounted
  useEffect(() => {
    getSubscribeList();
  }, []);

  // ----- 정보 가져오기
  const [membershipInfo, setMembershipInfo] = useState({});
  const membershipStatusTitle = {
    ING: "구독중",
    CANCEL: "구독해지",
    END: "구독종료",
  };

  const getSubscribeList = async () => {
    try {
      const response = (await PayApi.getByMembershipId(id)).data.data.content;
      setMembershipInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>

          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <DetailPageForm>
                <DetailFormTitle>상태</DetailFormTitle>
                <DetailFormText>{membershipStatusTitle[membershipInfo.membershipStatus] || "-"}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>아이디</DetailFormTitle>
                <DetailFormText>{membershipInfo.member?.account}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <DetailFormText>{membershipInfo.member?.name}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제일자</DetailFormTitle>
                <DetailFormText>{moment(membershipInfo.startDate).format("YYYY/MM/DD")}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>구독기간</DetailFormTitle>
                <DetailFormText>
                  {moment(membershipInfo.startDate).format("YYYY/MM/DD")} ~ {moment(membershipInfo.endDate).format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제금액</DetailFormTitle>
                <DetailFormText>{Number(membershipInfo.price || 0).toLocaleString()}원</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제수단</DetailFormTitle>
                <DetailFormText>정기결제 카드</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default SubscribeDetail;
